import { memo, useEffect, useState } from 'react'

import { Stack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'

type TimerProps = {
  durationInSeconds: number
  onTimerEnd: () => void
}
export const Timer = memo((props: TimerProps) => {
  const [timer, setTimer] = useState<number>(props.durationInSeconds)

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined = undefined

    if (timer > 0 && !interval) {
      interval = setInterval(() => {
        setTimer((prevSeconds) => prevSeconds - 1)
      }, 1000)
    } else if (timer === 0) {
      props?.onTimerEnd?.()
    }
    return () => {
      clearInterval(interval!)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer])

  const timeInMinutes = Math.floor(timer / 60)
  const timeInSeconds = timer % 60

  return (
    <Stack className="items-center justify-center">
      <SH3 className="text-primary-100">
        {`${timeInMinutes >= 10 ? '' : '0'}${timeInMinutes}`}:
        {`${timeInSeconds >= 10 ? '' : '0'}${timeInSeconds}`}
      </SH3>
    </Stack>
  )
})
